import React from "react";
import { Container, Image } from "react-bootstrap";
import hend from "../../../Asset/hend.svg";
import "./First.css";
import CareersSection from "./CareersSection";

const First = () => {
  return (
    <>
      <main
        className="main-content-wrapper"
        style={{ background: "var(--white-color)" }}
      >
        <section className="padding-top">
          <Container>
            <div className="hello_image">
              <Image src={hend} alt="Header Image" />
            </div>
            <h1 className="text-capitalize text-center top-h1">
              Let’s catch the initial spark!
            </h1>
          </Container>
        </section>
        <CareersSection />
      </main>
    </>
  );
};

export default First;
